import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { ServerService } from "../server.service";
@Component({
  selector: 'app-modulo-docente',
  templateUrl: './modulo-docente.component.html',
  styleUrls: ['./modulo-docente.component.css']
})
export class ModuloDocenteComponent implements OnInit {
  listaencuesta:any[]
  constructor(private router:Router,private server: ServerService) { }

  ngOnInit(): void {
      this.server.getEncuestasprofesores().subscribe((res:any)=>{
      this.listaencuesta= res;
   })

  }

  logout(): void{
    localStorage.removeItem("rol")
    this.router.navigateByUrl('/login');
  }

  redireccionar():void{

    this.router.navigateByUrl('/crear-encuesta');
  }

}
